import * as style from './style.css';
import React = require('react');

interface IProps {

    errors?: string[];
}

interface IState {

}

export default class TestBar extends React.Component<IProps, IState> {
    render() {
        return (
            <div className={style.testBar}>
           Wersja testowa
            </div>

        );
    }
}
